import { render, staticRenderFns } from "./covid-19-popup.html?vue&type=template&id=8fa4e276&scoped=true&"
import script from "./covid-19-popup.js?vue&type=script&lang=js&"
export * from "./covid-19-popup.js?vue&type=script&lang=js&"
import style0 from "./covid-19-popup.scss?vue&type=style&index=0&id=8fa4e276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa4e276",
  null
  
)

export default component.exports